<div class="dialog-page">
  <div class="header">
    <button mat-icon-button class="header-button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Agregar análisis clínico</h1>
    </div>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <mat-form-field appearance="outline" class="full">
      <mat-label>Estudio solicitado</mat-label>
      <input matInput placeholder="Ej. Biometría hemática" formControlName="estudio" />
      <mat-error>El estudio es obligatorio.</mat-error>
    </mat-form-field>

    <div class="file-upload">
      <button mat-stroked-button type="button" (click)="fileInput.click()">
        <mat-icon>upload_file</mat-icon>
        Subir resultado (PDF/imagen)
      </button>

      <input
        #fileInput
        type="file"
        hidden
        accept=".pdf,.jpg,.jpeg,.png"
        (change)="onArchivoSeleccionado($event)"
      />

      @if (archivoNombre) {
        <span class="archivo-nombre">{{ archivoNombre }}</span>
      }
    </div>

    <mat-form-field appearance="outline" class="full">
      <mat-label>Resumen del análisis</mat-label>
      <textarea
        matInput
        rows="4"
        placeholder="Resumen de los resultados..."
        formControlName="resumen"
      ></textarea>
      <mat-error>El resumen es obligatorio.</mat-error>
    </mat-form-field>
  </form>

  <div class="dialog-actions">
    <button mat-button type="button" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button class="add-boton" type="button" (click)="guardar()">
      Guardar
      <mat-icon>save</mat-icon>
    </button>
  </div>
</div>
